import React, { useEffect } from 'react'
import { useContext } from 'react'
import { AppContext } from "../context/AppContext";


const Test = () => {
  const {
    setIsUserDataLoading
  } = useContext(AppContext)

  useEffect(() => {
    setIsUserDataLoading(false)
  }, []) 

  return (
    <section className='section container'>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
        <h3>test</h3>
    </section>
  )
}

export default Test